module.exports = __webpack_public_path__ + "static/media/image3.b5aa90d1.jpg";